// Payment service - API calls for bank details and payments
import { apiClient } from './api';

/**
 * Payment Service
 * Handles all payment-related API calls including bank details and payment operations.
 */
export const paymentService = {
  // Bank Details
  getBankDetails: () => apiClient.get('/bank-details/'),
  getAllBankDetails: () => apiClient.get('/bank-details/'),
  getBankDetailsById: (id) => apiClient.get(`/bank-details/${id}/`),
  createBankDetails: (data) => apiClient.post('/bank-details/', data),
  updateBankDetails: (id, data) => apiClient.put(`/bank-details/${id}/`, data),
  patchBankDetails: (id, data) => apiClient.patch(`/bank-details/${id}/`, data),
  deleteBankDetails: (id) => apiClient.delete(`/bank-details/${id}/`),

  // Payments
  getPayments: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.employer_id) params.append('employer_id', filters.employer_id);
    if (filters.employee_id) params.append('employee_id', filters.employee_id);
    if (filters.job_posting_id) params.append('job_posting_id', filters.job_posting_id);
    // Only append status filters if they are not 'all' or empty
    if (filters.employer_payment_status && filters.employer_payment_status !== 'all') {
      params.append('employer_payment_status', filters.employer_payment_status);
    }
    if (filters.employee_payout_status && filters.employee_payout_status !== 'all') {
      params.append('employee_payout_status', filters.employee_payout_status);
    }
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    
    const queryString = params.toString();
    const endpoint = queryString ? `/payments/?${queryString}` : '/payments/';
    return apiClient.get(endpoint);
  },

  /**
   * Get payments for the authenticated user
   * Backend should filter by:
   * - For employees: only payments where employee_id matches authenticated user
   * - For employers: only payments where employer_id matches authenticated user
   * - For admins: all payments (or use getPayments instead)
   */
  getMyPayments: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    
    const queryString = params.toString();
    const endpoint = queryString ? `/payments/my_payments/?${queryString}` : '/payments/my_payments/';
    return apiClient.get(endpoint);
  },

  getPaymentDetails: (id) => apiClient.get(`/payments/${id}/`),

  getPaymentQRCode: (id) => apiClient.get(`/payments/${id}/qr_code/`),

  createPaymentRequest: (jobPostingId) => {
    return apiClient.post('/payments/create_request/', { job_posting_id: jobPostingId });
  },

  getPendingPayments: () => apiClient.get('/payments/pending/'),

  processPayout: (paymentId, notes = '') => {
    return apiClient.post(`/payments/${paymentId}/process_payout/`, { notes });
  },
};

export default paymentService;

